/**
 * H25 ทำเนียบยุทธภพ: the weekly fame boards window in the liked .ls-card frame. Key `;` or the HUD menu. One tab per
 * board, the top 10 and the player's own rank, this week's rewards. Reads `sys.fameBoards`; decides no rule.
 */
import { FAME, FAME_BOARDS, type World } from '@nine/shared';
import '../loading/loading.css';
import { h } from './dom';
import { lsCard, type LsCard } from './card';

const CSS = `
#fame.ls-card{position:fixed;left:50%;top:50%;bottom:auto;right:auto;transform:translate(-50%,-50%);width:min(460px,calc(100vw - 20px));max-height:calc(100vh - 20px);overflow-y:auto;z-index:60;gap:8px;padding:16px 18px;font-size:14px;line-height:1.5}
#fame[hidden]{display:none}
#fame h3{margin:0;font-size:18px;display:flex;justify-content:space-between;align-items:center}
#fame h3 button{font-size:16px;min-width:36px;min-height:36px;cursor:pointer}
#fame .fm-tabs{display:flex;flex-wrap:wrap;gap:4px}
#fame .fm-tabs button{min-height:30px;padding:0 8px;cursor:pointer;border:1px solid rgba(244,241,234,.3);background:rgba(22,19,15,.6);color:#d4cec3;border-radius:5px;font-size:12px}
#fame .fm-tabs button.on{background:#a3281f;border-color:#d6412f;color:#fff}
#fame ol{margin:0;padding:0;list-style:none}
#fame li{display:flex;justify-content:space-between;gap:8px;padding:1px 4px}
#fame li.me{background:rgba(246,196,108,.18);color:#f6c46c}
#fame .fm-note{color:#d4cec3;font-size:12px}
`;

export class FameWindow {
  private tab = 0;
  private readonly card: LsCard;

  constructor(private readonly world: World) {
    document.head.append(h('style', {}, CSS));
    this.card = lsCard({ id: 'fame', title: 'ทำเนียบยุทธภพ', key: ';', menuId: 'mbFame', refreshEvery: 2, draw: (body) => this.draw(body) });
  }

  get isOpen(): boolean {
    return this.card.isOpen;
  }
  toggle(): void {
    this.card.toggle();
  }
  open(): void {
    this.card.open();
  }
  close(): void {
    this.card.close();
  }
  sync(dt: number): void {
    this.card.sync(dt);
  }

  private draw(body: HTMLElement): void {
    const sys = this.world.sys.fameBoards;
    const b = FAME_BOARDS[this.tab]!;
    const tabs = h(
      'div',
      { class: 'fm-tabs' },
      ...FAME_BOARDS.map((d, i) => {
        const btn = h('button', { type: 'button', class: i === this.tab ? 'on' : '' }, d.name);
        btn.addEventListener('click', () => {
          this.tab = i;
          this.card.redraw();
        });
        return btn;
      }),
    );
    const rows = sys.standings(b.id);
    const mine = rows.findIndex((r) => r.me);
    const top = rows.slice(0, FAME.top);
    const list = h(
      'ol',
      {},
      ...top.map((r, i) => h('li', { class: r.me ? 'me' : '' }, h('span', {}, `${i + 1}. ${r.name}`), h('span', {}, `${r.score}`))),
    );
    const you =
      mine >= FAME.top
        ? h('ol', {}, h('li', { class: 'me' }, h('span', {}, `${mine + 1}. ${rows[mine]!.name}`), h('span', {}, `${rows[mine]!.score}`)))
        : null;
    body.replaceChildren(
      tabs,
      h('div', { class: 'fm-note' }, `${b.unit} · อันดับ 1 ได้ฉายา「${b.title}」และ${b.outfit} · อันดับ 2-3 ได้เงิน · รีเซ็ตทุกวันจันทร์ 05:00`),
      list,
      ...(you ? [you] : []),
    );
  }
}
